
import NoteText from "./NoteText";

export default NoteText;